import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PLAN_GiaoVien } from '../../services/giao-vien/GiaoVienModels';

interface GiaoVienState {
    listData: PLAN_GiaoVien[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    selectedId: string | null;
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: PLAN_GiaoVien | null;
}

const initialState: GiaoVienState = {
    listData: [],
    status: 'idle',
    selectedId: null,
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: null
};

const giaoVienSlice = createSlice({
    name: 'giaoVien',
    initialState,
    reducers: {
        setList: (state, action: PayloadAction<PLAN_GiaoVien[]>) => {
            state.listData = action.payload;
        },
        setStatus: (state, action: PayloadAction<GiaoVienState['status']>) => {
            state.status = action.payload;
        },
        selectGiaoVien: (state, action: PayloadAction<string | null>) => {
            state.selectedId = action.payload;
        },
        setCreateOrEditModel: (state, action: PayloadAction<PLAN_GiaoVien | null>) => {
            state.createOrEditModel = action.payload;
        },
        setShowCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<{ show: boolean; id?: string }>) => {
            state.isShowConfirmDeleteModal = action.payload.show;
            state.selectedId = action.payload.id ?? null;
        },
        insertSuccess: (state, action: PayloadAction<PLAN_GiaoVien>) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateSuccess: (state, action: PayloadAction<PLAN_GiaoVien>) => {
            const index = state.listData.findIndex((item) => item.ID_cb === action.payload.ID_cb);
            if (index !== -1) {
                state.listData[index] = action.payload;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteSuccess: (state, action: PayloadAction<string>) => {
            state.listData = state.listData.filter((item) => item.ID_cb !== action.payload);
            state.isShowConfirmDeleteModal = false;
            if (state.selectedId === action.payload) {
                state.selectedId = null;
            }
        },
        resetState: () => initialState
    }
});

export const {
    setList,
    setStatus,
    selectGiaoVien,
    setCreateOrEditModel,
    setShowCreateOrEditModal,
    setShowConfirmDeleteModal,
    insertSuccess,
    updateSuccess,
    deleteSuccess,
    resetState
} = giaoVienSlice.actions;

export const giaoVienReducer = giaoVienSlice.reducer;
